



























































































































































































































import { Component, Vue,Prop, Model, Watch  } from "vue-property-decorator";
import {
  getContactProperty,
  getContactPropertyDetail
} from "@/services/api";
import YcColorPicker from "@/components/color-picker/index.js";

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
  },
})
export default class componentSetForm extends Vue {

  @Prop(Object)
  setformType!:object;

  @Prop(Array)
  formList!:any;

  @Prop(Array)
  countryList!:any

  formType: any = {}

  formAddList =["Email",'Mobile Number','First Name','Last Name',"Birthday"]
  defaultCountry = {}
  newFormList = JSON.parse(JSON.stringify(this.formList))
  companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id
  necessary = true
  placeholder = ''
  List = []
  questionType = ''//单选 多选
  questionTypeList = [
    {id: 'Single',
      "value": "单选题"},
    {id: 'Multiple',
      "value": "多选题"},
    {id: 'Date', value: '日期选择'}
  ]
  question = ""
  questionOptionList = []
  optionList = []
  optionListList = []
  formatString = 'yyyy-MM-dd';

  get showSetCheckbox() {
    return sessionStorage.getItem('popType')==='POP_WINDOW';
  }

  filterQuestionOptionList(questionType: string) {
    return this.questionOptionList.filter(item => item.valueType === (questionType === 'Date' ? 3 : 0));
  }

  async created(): Promise<void> {
    this.init()
    this.getContactProperty()
  }
  init(){
    this.formType = JSON.parse(JSON.stringify(this.setformType))
    // 日期格式适配
    if (this.formType.formatString) {
      this.formatString = this.formType.formatString;
    } else {
      this.formType.formatString = this.formatString;
    }
    console.log('form init', JSON.stringify(this.formType));
    this.defaultCountry['countryAbbreviation'] = this.formType.phoneCountryAbbreviation;
    this.defaultCountry['phoneCode'] = this.formType.phoneCode;
    if (this.formType.type === '自定义'){
      let optionList = []
      for (let i = 0; i < this.setformType.optionList.length; i++) {
        optionList.push(this.setformType.optionList[i].value);
      }
      if(!optionList[0]){
        optionList = ['','']
      }
      this.optionList = optionList

      this.getContactPropertyDetail(this.formType.attributeId);
    }
  }
  changeAttribute(item:any){
    this.newFormList.forEach((i:any)=>{
      if (i.attribute === item) {
        this.$message.error('您添加了多个 《' + i.label + '》 属性,请检查设置是否有误' )
        this.formType.attribute = ''
        return
      }
    })
    let id = this.questionOptionList.filter((item)=>{
      if(item.name == this.formType.attribute){
        return item
      }
    })
    if(id[0]?.id && !id[0].routine){
      this.formType.attributeId = id[0]?.id;
      this.formatString = id[0]?.formatString;
      this.formType.formatString = id[0]?.formatString;
      this.getContactPropertyDetail(id[0]?.id)
    }else{
      this.formType.attributeId = null;
      this.optionListList = []
    }
  }

  async getContactProperty(){
    let { data ,status} = await getContactProperty({},false)
    if (status == 200) {
      this.questionOptionList = data.data;
    }
  }

  changeCountryCode(country){
    this.formType.phoneCode = country.phoneCode;
    this.formType.phoneCountryAbbreviation = country.countryAbbreviation;
  }

  changeFormatString(val) {
    this.formType.formatString = val;
  }

  async getContactPropertyDetail(id:number){
    if(id){
      let { data ,status} = await getContactPropertyDetail({
        propertyId:id
      },false)
      if (status == 200) {
        this.optionListList = data.data.valueList;
      }
    }else{
      this.optionListList = []
    }
  }

  getCompanyId() {
    const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    return company?.id;
  }

  save(){
    console.log('befere save:', JSON.stringify(this.formType));
    if(this.formType.type === 'Mobile Number' && !this.formType.privacyPolicyLink) {
      this.$message.error("提供您商店的Privacy policy链接");
      return
    }
      //校验相关属性
    if(this.formType.type === '自定义'){
      if(!this.formType.attribute){
        this.$message.error("请选择相关属性");
        this.$nextTick(() => {
          const attributeEl: any = this.$refs.attribute;
          attributeEl.focus();
        })
        return
      }
      if(!this.formType.questionType){
        this.$message.error("请选择单选或者多选或者日期");
        this.$nextTick(() => {
          const questionTypeEl: any = this.$refs.questionType;
          questionTypeEl.focus();
        })
        return
      }
      let hash = {}

      let id = this.questionOptionList.filter((item)=>{
        if(item.name == this.formType.attribute){
          return item
        }
      })
      if (id[0]) {
        this.formType.attributeId = id[0].id;
        this.formType.routine = id[0].routine;
      } else {
        this.formType.attributeId = null
        this.formType.routine = false
      }

      let newOptionList = []
      if (this.formType.questionType === 'Date') {
        if (!this.formType.question) {
          this.$message.error("有选项未设置，请设置后重新保存");
          return
        }
      } else {
        for (let i = 0; i < this.optionList.length; i++) {
          if (!this.optionList[i]) {
            console.log(hash)
            this.$message.error("有选项未设置，请设置后重新保存");
            return
          }
          let newObj = this.optionListList.filter((item)=>{
            if(item.value == this.optionList[i]){
              return item
            }
          })
          if(newObj[0]){
            newOptionList.push(newObj[0])
            if(hash[newObj[0].value]){
              this.$message.error("不可设置相同的选项，请修改后重新保存");
              return
            }
            hash[newObj[0].value] = true
          }else{
            newOptionList.push({
              value:this.optionList[i]
            })
            if(hash[this.optionList[i]]){
              this.$message.error("不可设置相同的选项，请修改后重新保存");
              return
            }
            hash[this.optionList[i]] = true
          }
        }
      }

      if (this.formType.questionType === 'Date') {
        if (id[0]) {
          this.formType.label = id[0].label;
        } else {
          this.formType.label = this.formType.attribute;
        }
        this.formType.valueType = 3;
      } else {
        this.formType.label = this.formType.attribute
      }
      this.formType.optionList = newOptionList;
    }

    console.log('after save: ', JSON.stringify(this.formType));
    this.$emit('changFormItem',this.formType)
    this.$emit('close',false)
  }

  close(){
    this.$emit('close',false)
  }

  creatOption(){
    if(this.optionList.length < 10){
      this.optionList.push('')
    }else{
      this.$message.error("选项最多只能有10个");
    }
  }
  changeOptionList(index:Number){
    if(this.optionList[index].length > 50){
      this.optionList[index] = this.optionList[index].substring(0,50)
      this.$message.error("最多为50个字符");
    }
  }
  delOption(index:number){
    this.optionList.splice(index,1)
  }
  @Watch('setformType')
  setformTypeWatch(val:any){
    this.formType = JSON.parse(JSON.stringify(this.setformType))
  }
  @Watch('setformType.optionList')
  optionListWatch(val:any){
    this.optionList = val
  }
  @Watch('formType.attribute')
  attributeWatch(val:any,old:any){
    if(typeof(val) === 'undefined'){
      return
    }
    if(typeof(old) === 'undefined'){
      return
    }
    this.formType.question = ''
    this.optionList = ['','']
  }
  @Watch('formType.questionType')
  questionTypeWatch(val:any,old:any){
    if(typeof(val) === 'undefined'){
      return
    }
    if(typeof(old) === 'undefined'){
      return
    }
    this.formType.attribute = ''
    this.formType.question = ''
    this.optionList = ['','']
  }
}
